// @flow
export default (terms: string = '', orsToCommas: boolean = false) => {
    if (!terms || typeof terms !== 'string') {
        return '';
    }
    if (!terms.trim()) {
        return '';
    }
    if (orsToCommas) {
        return terms
            .replace(/\\"/g, '')
            .replace(',', '')
            .replace(/ OR/g, ',');
    }
    return terms
        .replace(/\\"/g, '')
        .replace(/OR /g, '')
        .trim();
};
